import React from 'react';
import { Tag } from 'primereact/tag';
import { Badge } from 'primereact/badge';

const renderValue = (value: any, fieldName: string, valueType: string) => {
    if (value === null || typeof value === 'undefined') {
        return <span style={{ color: 'grey' }}>N/A</span>;
    }

    // Specific handling for createdDate timestamps
    if (fieldName === 'createdDate' && typeof value === 'number') {
        return new Date(value).toLocaleString();
    }

    if (Array.isArray(value)) {
        if (value.length === 0) {
            return <span style={{ fontStyle: 'italic' }}>Empty Array</span>;
        }
        return (
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.25rem' }}>
                {value.map((item, index) => (
                    <div key={`${fieldName}-${valueType}-item-${index}`} style={{ marginBottom: '0.25rem' }}>
                        {typeof item === 'object' && item !== null ? (
                            <div style={{ border: '1px solid #eee', padding: '0.25rem', borderRadius: '4px', background: '#f9f9f9' }}>
                                {renderValue(item, `${fieldName}[${index}]`, valueType)} {/* Recursive call for objects in array */}
                            </div>
                        ) : (
                            <Badge value={String(item)}></Badge>
                        )}
                    </div>
                ))}
            </div>
        );
    }

    if (typeof value === 'object') {
        const entries = Object.entries(value);
        if (entries.length === 0) {
            return <span style={{ fontStyle: 'italic' }}>Empty Object</span>;
        }
        return (
            <div style={{ paddingLeft: '1rem', borderLeft: '2px solid #ddd', marginTop:'0.25rem', marginBottom:'0.25rem' }}>
                {entries.map(([key, val]) => (
                    <div key={`${fieldName}-${valueType}-prop-${key}`} style={{ marginBottom: '0.25rem' }}>
                        <strong>{key}: </strong>
                        {renderValue(val, `${fieldName}.${key}`, valueType)} {/* Recursive call for object properties */}
                    </div>
                ))}
            </div>
        );
    }

    return String(value);
};

export default renderValue;